var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 20,
    viewBox: "0 0 19 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7068 3.45694L15.2532 1.9096C15.5756 1.58723 16.0128 1.40613 16.4687 1.40613C16.9246 1.40613 17.3619 1.58723 17.6842 1.9096C18.0066 2.23198 18.1877 2.6692 18.1877 3.1251C18.1877 3.58101 18.0066 4.01823 17.6842 4.3406L7.95017 14.0747C7.46555 14.559 6.86792 14.915 6.21125 15.1105L3.75 15.8439L4.48333 13.3826C4.67884 12.7259 5.03483 12.1283 5.51917 11.6437L13.7068 3.45694ZM13.7068 3.45694L16.125 5.8751M14.75 12.1772V16.5314C14.75 17.0784 14.5327 17.603 14.1459 17.9898C13.7591 18.3766 13.2345 18.5939 12.6875 18.5939H3.0625C2.51549 18.5939 1.99089 18.3766 1.60409 17.9898C1.2173 17.603 1 17.0784 1 16.5314V6.90635C1 6.35934 1.2173 5.83474 1.60409 5.44795C1.99089 5.06115 2.51549 4.84385 3.0625 4.84385H7.41667",
    stroke: "#DBB57C",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.32feed84ebd549344898dc98c7131bf3.svg";
export { ForwardRef as ReactComponent };